'use client'

import ImageWithFallback from '@/components/common/image-with-fallback'
import { Button } from '@/components/ui/button'
import { urlSafeProfilePath } from '@/helpers/url-safe-profile-path'
import { getUserProfilePictureUrl } from '@/helpers/user'
import { getDriverDisplayIdentifierDisplay } from '@/lib/driver-display-identifiers'
import Link from 'next/link'
import EventAttendeeStatusButton from './event-attendee-status-button'

export default function ChampEventDriversSection({
  event,
  isFinished,
  session,
  eventDrivers,
  mutateEventDrivers,
  showSplits,
  showCarClasses,
}) {
  return (
    <div className="w-full">
      {eventDrivers.length === 0 ? (
        <div className="mt-6 flex items-center rounded-sm border border-neutral-blue-700 bg-neutral-blue-800 py-10">
          <h5 className="m-auto text-center">This event has no drivers</h5>
        </div>
      ) : (
        <>
          <div className="mt-0 hidden grid-cols-10 desktop-xs:mt-6 desktop-xs:grid">
            <p className="col-span-3 text-[12px] font-semibold leading-[14px] tracking-[4px] text-neutral-blue-500">
              USER
            </p>

            {showSplits && (
              <p className="col-span-2 text-[12px] font-semibold leading-[14px] tracking-[4px] text-neutral-blue-500">
                TIER/SPLIT
              </p>
            )}

            {showCarClasses && (
              <p className="col-span-2 text-[12px] font-semibold leading-[14px] tracking-[4px] text-neutral-blue-500">
                CAR CLASS
              </p>
            )}

            {!showSplits && <div className="col-span-2" />}
            {!showCarClasses && <div className="col-span-2" />}

            <div className="col-span-3"></div>
          </div>

          <div className="mt-6">
            {eventDrivers.map((attendee, index) => (
              <Link
                className="group -ml-5 flex items-center justify-between gap-3 rounded-md py-4 pl-5 pr-0 align-middle font-inter transition-all ease-in-out desktop-xs:grid desktop-xs:grid-cols-10 desktop-xs:pr-[14px] desktop-xs:hover:bg-neutral-blue-800"
                key={index}
                href={urlSafeProfilePath({
                  ...attendee.user,
                  id: attendee.userId,
                  profileType: 'driver',
                })}
                target="_blank"
              >
                <div className="col-span-7 flex items-center gap-3 align-middle desktop-xs:col-span-3">
                  <div className="relative aspect-square w-10 min-w-10 overflow-hidden rounded-full">
                    <ImageWithFallback
                      src={getUserProfilePictureUrl(attendee.user)}
                      alt="A users profile picture"
                      fill
                    />
                  </div>
                  <div className="flex flex-col">
                    <p className="truncate-1 break-all pb-[2px] text-p-1 font-normal desktop-xs:text-p-2">
                      {getDriverDisplayIdentifierDisplay(attendee, 'nickname')}
                    </p>
                  </div>
                </div>

                {showSplits && (
                  <div className="col-span-2 hidden desktop-xs:block">
                    {attendee.user.attendingChampionships[0]?.split?.name ? (
                      <p className="truncate-1 break-all pb-[2px] text-p-1 font-normal desktop-xs:text-p-2">
                        {attendee.user.attendingChampionships[0].split.name}
                      </p>
                    ) : (
                      <p className="truncate-1 break-all pb-[2px] text-p-1 font-normal text-neutral-blue-500 desktop-xs:text-p-2">
                        -
                      </p>
                    )}
                  </div>
                )}

                {showCarClasses && (
                  <div className="col-span-2 hidden desktop-xs:block">
                    {attendee.user.attendingChampionships[0]?.carClass?.name ? (
                      <p className="truncate-1 break-all pb-[2px] text-p-1 font-normal desktop-xs:text-p-2">
                        {attendee.user.attendingChampionships[0].carClass.name}
                      </p>
                    ) : (
                      <p className="truncate-1 break-all pb-[2px] text-p-1 font-normal text-neutral-blue-500 desktop-xs:text-p-2">
                        -
                      </p>
                    )}
                  </div>
                )}

                {!showSplits && <div className="col-span-2" />}
                {!showCarClasses && <div className="col-span-2" />}

                <div className="col-span-1"></div>

                <div className="col-span-2 flex">
                  <Button
                    variant="outline"
                    className="bg-neutral-blue-900! hover:bg-white! hover:text-black! desktop-xs:group-hover:bg-white! desktop-xs:group-hover:text-black! ml-auto mr-0 py-2 font-inter text-p-1 transition-all ease-in-out desktop-xs:py-3"
                  >
                    View
                    <span className="hidden tablet:inline-block">
                      &nbsp;profile
                    </span>
                  </Button>
                </div>
              </Link>
            ))}
          </div>
        </>
      )}

      {!isFinished && session ? (
        <>
          <div className="mt-5 hidden desktop-xs:block">
            <EventAttendeeStatusButton
              event={event}
              session={session}
              mutateEventDrivers={mutateEventDrivers}
              hideIfRegistered
              hideJoiningInfoButton
              enableDonationCampaign
            />
          </div>
          <div className="divide mt-10" />
        </>
      ) : (
        <div className="divide mt-6" />
      )}
    </div>
  )
}
